import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const suppliersPageContext = React.createContext({});
export let suppliersPageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMSuppliersGetContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  suppliersPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(suppliersPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    suppliersPageMachine,
    suppliersPageState: state,
    suppliersPageSend: send,
  };
};
